import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlModalHeaderComponent } from './sl-modal-header/sl-modal-header.component';
import { SlModalFooterComponent } from './sl-modal-footer/sl-modal-footer.component';
import { SlModalBodyComponent } from './sl-modal-body/sl-modal-body.component';
import { SlModalConfig } from './interfaces/sl-modal.interfaces';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'sl-modal',
  standalone: true,
  imports: [
    CommonModule,
    SlModalHeaderComponent,
    SlModalHeaderComponent,
    SlModalBodyComponent,
    SlModalFooterComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './sl-modal.component.html',
  styleUrl: './sl-modal.component.scss',
})
export class SlModalComponent implements OnChanges {
  @Input() showModal = false;
  @Input({ required: true }) config!: SlModalConfig;
  @Input() formGroup?: FormGroup;
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() primaryButtonClickEvent: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() secondaryButtonClickEvent: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() tertiaryButtonClickEvent: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() submitEvent: EventEmitter<void> = new EventEmitter<void>();

  readonly cdRef = inject(ChangeDetectorRef);

  @ViewChild('modalRef')
  modalRef!: ElementRef;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showModal'] && this.showModal) {
      this.cdRef.detectChanges();
      const focusableElements = this.getFocusableElements();
      if (focusableElements?.length > 0) {
        focusableElements[0].focus();
      }
    }
  }

  onClickClose() {
    this.closeEvent.emit(false);
  }

  onClickPrimaryButton() {
    this.primaryButtonClickEvent.emit();
  }

  onClickSecondaryButton() {
    this.secondaryButtonClickEvent.emit();
  }

  onClickTertiaryButton() {
    this.tertiaryButtonClickEvent.emit();
  }

  onKeyDownModal(event: KeyboardEvent) {
    const focusableElements = this.getFocusableElements().slice(1);
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  getFocusableElements(): HTMLElement[] {
    return Array.from(
      this.modalRef.nativeElement.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable], [role="button"]'
      )
    );
  }

  getFormGroup() {
    return this.formGroup || new FormGroup({});
  }
  onSubmit() {
    this.submitEvent.emit();
  }
}
